export default "__VITE_ASSET__BHQRuS3___"